import Peer from "./Peer";

export default class Consumers {

    consumers = {};

    constructor() {
        this.peer = new Peer();
        this.preferredLayers = 2;
    }

    async init() {
        await this.peer.start('recv');
    }

    setPreferredLayers(value) {
        switch(value) {
            case '180p':
                this.preferredLayers = 0;
                break;
            case '360p':
                this.preferredLayers = 1;
                break;
            default: 
                this.preferredLayers = 2;
                break;
        }
    }

    count() {
        let count = 0;
        for(var i in this.consumers) {
            for(var j in this.consumers[i]) {
                if(this.consumers[i][j].closed !== true)
                    count++;
            }
        }
        return count;
    }

    getAll() {
        return this.consumers;
    }

    getPeer() {
        return this.peer;
    }

    updateLayers() {
        for(var peerId in this.consumers) {
            for(var mediaTag in this.consumers[peerId]) {
                if(mediaTag.includes('video'))
                    this.consumers[peerId][mediaTag].setPreferredLayers({ spatialLayer: this.preferredLayers });
            }
        }
    }

    async consume(peerId, mediaTag) {    
        if(window.sdk.session().isExtern()) {
            //we do not consume any participant when we are external camera
            return false;
        }
        console.log('mediasoup', 'consumer', 'consume', peerId, mediaTag);
        if(!this.consumers[peerId])
            this.consumers[peerId] = {}
        this.consumers[peerId][mediaTag] = await this.peer.startConsume(peerId, mediaTag);        
        if(mediaTag == 'cam-video') //.includes('video'))
            this.consumers[peerId][mediaTag].setPreferredLayers({ spatialLayer: this.preferredLayers });
        return this.consumers[peerId][mediaTag];
    } 

    async pause(peerId, mediaTag) {
        if(!this.consumers[peerId])
            return;
        let consumer = this.consumers[peerId][mediaTag];
        if(consumer) {
            await this.consumers[peerId][mediaTag].pause2();
            return this.consumers[peerId][mediaTag];
        }
    }

    async resume(peerId, mediaTag) {
        if(!this.consumers[peerId])
            return;
        let consumer = this.consumers[peerId][mediaTag];
        if(consumer) {
            await this.consumers[peerId][mediaTag].resume2();
            return this.consumers[peerId][mediaTag];
        }
    }

    async stop(peerId, mediaTag) {
        if(!this.consumers[peerId])
            return;
        let consumer = this.consumers[peerId][mediaTag];
        let res = {
            id: consumer.id,
            mediaTag: mediaTag
        }
        if(consumer) {
            await this.consumers[peerId][mediaTag].close2();
            return res;          
        }
    }

    async stopByPeerId(peerId) {
        let consumers = [];
        for(var mediaTag in this.consumers[peerId]) {
            consumers.push({
                id: this.consumers[peerId][mediaTag].id,
                mediaTag: mediaTag
            })
            await this.consumers[peerId][mediaTag].close2();
        }
        return consumers;
    }
    
    async closeAll() {
        for(var i in this.consumers) {
            for(var j in this.consumers) {
                try {
                    await this.consumers[i][j].close2();
                }
                catch(err) {
                    console.error(err);
                }
            }
        }
    }

    async removePeer() {
        await this.peer.sig('/remove-peer');   
        await this.closeAll();                 
        await this.peer.close();    
    }



}